module.exports = __webpack_public_path__ + "img/W7007-trad.97652915.jpg";